﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import type { PostSelfServiceRegistrationRequest } from "./PostSelfServiceRegistration";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (): string => {
    const uri = "api/sopnl/v1/selfservice/register/status";

    return uri;
};

const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export enum DataGatheringStatus {
    /** Has not yet started. */
    Pending = "Pending",
    /** The gathering operation has started. */
    InProgress = "InProgress",
    /** The gathering operation has collected the information, but it may not yet be stored in the repository. */
    Collected = "Collected",
    /** Skipped since it cannot be handled. This will happen when a data source is disabled. */
    Skipped = "Skipped",
    /** Completed successfull. */
    Success = "Success",
    /** Completed with a warning. */
    Warning = "Warning",
    /** Did not complete. */
    Error = "Error",
}

export interface PostSelfServiceRegistrationStatusResponse {
    Status: DataGatheringStatus;
}

export interface PostSelfServiceRegistrationStatusProps extends api.ApiHookBaseProps<
    PostSelfServiceRegistrationRequest,
    PostSelfServiceRegistrationStatusResponse,
    unknown
> {
    pollInterval: number;
}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function usePostSelfServiceRegistrationStatus(
    props: PostSelfServiceRegistrationStatusProps
): [boolean] {
    const { pollInterval, ...otherProps } = props;

    const apiParams: api.PollApiHookProps<
        unknown,
        PostSelfServiceRegistrationStatusResponse,
        unknown
    > = {
        ...otherProps,
        interval: pollInterval,
        uri: uri(),
        method: method,
    };

    const loading = api.usePollApi<
        unknown,
        PostSelfServiceRegistrationStatusResponse,
        unknown
    >(apiParams);

    return [loading];
}
